import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import Select from "react-select";
import {queryParamsToObject} from "../DataTableUtils";
import {selectStyle} from "../../../../helpers/utils/StyleUtils";
import {FaSearch} from "react-icons/fa";
import CommonSelectorModal from "../../form/CommonSelectorModal";

interface SelectWrapperProps {
    name?: string;
    accessor?: string;
    classNamePrefix: string;
    isMulti?: boolean;
    menuShouldBlockScroll?: boolean;
    menuShouldScrollIntoView?: boolean;
    tabSelectsValue?: boolean;
    backspaceRemovesValue?: boolean;
    defaultValue?: any,
    isConstantData?: boolean;
    options: { label: string, value: string }[];
    placeholder: string;
    onChange?: Function;
}

export const SearchSelectWrapper: React.FC<SelectWrapperProps> = (props: SelectWrapperProps) => {

    const location: any = useLocation();

    const {
        name = '',
        accessor = '',
        classNamePrefix,
        isMulti,
        menuShouldBlockScroll,
        menuShouldScrollIntoView,
        tabSelectsValue,
        backspaceRemovesValue,
        defaultValue,
        isConstantData = false,
        options,
        placeholder,
        onChange,
    } = props;

    let [values, setValues] = useState(defaultValue);
    const [optionState, setOptionState] = useState(null as any);


    //to prevent re-rendering of options multiple times when options are unChanged...
    useEffect(() => {

        if ((optionState === null || optionState === undefined) && isConstantData) {
            setOptionState(options);
        } else {
            setOptionState(options);
        }

    }, [options]);


    useEffect(() => {

        if (location.search) {
            const queryParamsObject = queryParamsToObject(location.search);

            isMulti ?
                // @ts-ignore
                setValues(queryParamsObject?.hasOwnProperty(accessor) ? queryParamsObject[accessor] : [defaultValue])
                :
                // @ts-ignore
                setValues(queryParamsObject?.hasOwnProperty(accessor) ? queryParamsObject[accessor] : defaultValue);
        }


    }, [location.search]);

    useEffect(() => {
        if (optionState) {
            if (queryParamsToObject(location.search) instanceof Object && Object.keys(queryParamsToObject(location.search)).length > 0) {
                Object.keys(queryParamsToObject(location.search)).map((cur, i) => {
                    if (cur === accessor) {
                        //@ts-ignore
                        setValues(values);
                    }
                })
            }
        }
    }, [optionState]);

    useEffect(() => {
        if (location.search) {
            if (queryParamsToObject(location.search) instanceof Object && Object.keys(queryParamsToObject(location.search)).length > 0) {
                Object.keys(queryParamsToObject(location.search)).map((cur, i) => {
                    if (cur === accessor) {
                        //@ts-ignore
                        setValues(queryParamsToObject(location.search)[cur]);
                    }
                })
            }
        }
    }, []);


    const handleChange = (value: any) => {

        location.state = undefined;
        setValues(value && Array.isArray(value) ? value.map(subValue => subValue.value) : value?.value);

        if (!onChange) return;
        onChange(value && Array.isArray(value) ? value.map(subValue => subValue.value) : value?.value);
    };

    return <Select
        name={name}
        classNamePrefix={classNamePrefix}
        isMulti={isMulti}
        menuShouldBlockScroll={menuShouldBlockScroll}
        menuShouldScrollIntoView={menuShouldScrollIntoView}
        tabSelectsValue={tabSelectsValue}
        backspaceRemovesValue={backspaceRemovesValue}
        blurInputOnSelect={!isMulti}
        isClearable
        //@ts-ignore
        options={optionState}
        placeholder={placeholder}
        onChange={handleChange}
        styles={selectStyle}
        isDisabled={!optionState || !optionState.length}
        filterOption={(option: any, inputValue) => {
            const groomedInput =  inputValue?.trim().toLowerCase();

            if ((typeof option?.label === 'string' || option?.label instanceof String)) {
                return option?.label.toLowerCase().includes(groomedInput);
            }

            let json = JSON.stringify(option?.label?.props)?.toLowerCase();
            return json ? json.includes(groomedInput) : true;
        }
        }

        value={getObjectiveDataWithMatchedData(isMulti, optionState, values, setValues, "value")}
    />;
};

//@ts-ignore
function getObjectiveDataWithMatchedData(isMulti, options, values, setValues, valueToReturn) {

    if (values === null || values === "") {
        return null;
    } else if (isMulti && Array.isArray(options) && options.length > 0 && Array.isArray(values)) {
        return options.filter(cur => values.indexOf(cur[valueToReturn]) >= 0).length === 0 ? null : options.filter(cur => values.indexOf(cur[valueToReturn]) >= 0);
    } else if (!isMulti && Array.isArray(options) && options.length > 0 && values !== null) {
        return options.find(cur => cur[valueToReturn] === values);
    } else {
        setValues(null);
        return null;
    }
}

//@ts-ignore
export function SearchSelectWithEnum(enumMap, placeholderText, isMulti, accessor, defaultValue: any = null, quickFilters = null, isConstantData = false) {
    return SearchSelectWithList(enumMap, "value", "constant", placeholderText, isMulti, accessor, defaultValue, quickFilters, isConstantData);
}

// Label/value can be either a Function or a string
// This is useful when the label/value are built based on other things, like 'CustomerName (CustomerNumber)'
//@ts-ignore
export function SearchSelectWithList(itemMap, label, value, placeholderText, isMulti, accessor, defaultValue = null, quickFilters = null, isConstantData = false) {
    const options = itemMap && Array.isArray(itemMap) && itemMap?.map(item => {
        return {
            value: value instanceof Function ? value(item) : item[value],
            label: label instanceof Function ? label(item) : item[label]
        }
    });

    return <SearchSelectWrapper
        classNamePrefix="select"
        accessor={accessor}
        isConstantData={isConstantData}
        isMulti={isMulti}
        menuShouldBlockScroll
        menuShouldScrollIntoView
        tabSelectsValue
        options={options}
        placeholder={placeholderText}
        defaultValue={defaultValue}
    />;
}

export function SearchInputWithModal({
                                         placeholder,
                                         value,
                                         onChange,
                                         modalTitle,
                                         modalColumns,
                                         rtkQueryHook,
                                         getLabel = (row: any) => row?.name || row?.label || "",
                                     }: {
    placeholder?: string;
    value?: string;
    onChange: (value: any) => void;
    modalTitle: string;
    modalColumns: any[];
    rtkQueryHook: any;
    getLabel?: (row: any) => string;
}) {
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);

    const handleSubmit = () => {
        if (selectedRow) {
            onChange(getLabel(selectedRow));
        }
        setShowModal(false);
    };

    return (
        <>
            <div className="relative flex items-center gap-2">
                <input
                    type="text"
                    value={value || ""}
                    readOnly
                    placeholder={placeholder}
                    className="form-input w-full"
                />
                <FaSearch
                    className="text-gray-500 cursor-pointer"
                    onClick={() => setShowModal(true)}
                />
            </div>

            <CommonSelectorModal
                title={modalTitle}
                columns={modalColumns}
                data={rtkQueryHook}
                show={showModal}
                onSubmit={handleSubmit}
                setShow={setShowModal}
                setSelectedRow={setSelectedRow}
            />
        </>
    );
}


